import INVENTORY_API_BASE_URL from "../../config/api";
import { apiFetch } from "../../config/apiClient";
import { getCurrentUser } from "aws-amplify/auth";

const logUserActivity = async (action, details = {}) => {
  try {
    const user = await getCurrentUser();

    await apiFetch(`${INVENTORY_API_BASE_URL}/log-activity`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: user.userId,
        email: user.signInDetails?.loginId || "N/A",
        name: user?.signInDetails?.loginId?.split("@")[0] || "Unknown",
        action,
        details,
      }),
    });
  } catch (error) {
    console.error("Error logging user activity:", error);
  }
};

export default logUserActivity;
